"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import e from "../components/Icon/SvgIcon.js";
const t = (r) => /* @__PURE__ */ o(
  e,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...r,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.13 4.764a2 2 0 0 1 .745.744l7.836 13.713a.5.5 0 0 1-.434.748H3a.5.5 0 0 1-.434-.748l7.836-13.713a2 2 0 0 1 2.729-.744M12.139 6.5 5.584 17.97h13.108z",
        clipRule: "evenodd"
      }
    )
  }
), p = l(t);
export {
  p as ArrowUp,
  p as default
};
